import { useEffect, useState } from 'react';

export const isMobileDevice = () => {
    const hasWindow = globalThis.window !== undefined;
    const width = hasWindow ? window.innerWidth : 769;
    return width <= 768;
};

const useWindowDimensions = () => {
    const hasWindow = globalThis.window !== undefined;
    const [windowDimensions, setWindowDimensions] = useState({
        width: hasWindow ? window.innerWidth : 769,
        height: hasWindow ? window.innerHeight : 769,
    });

    useEffect(() => {
        if (hasWindow) {
            const handleResize = () => {
                setWindowDimensions({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            };

            window.addEventListener('resize', handleResize);

            // Cleanup function to remove the event listener
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [hasWindow]);

    return windowDimensions;
};

export const useIsMobileDevice = () => {
    const [isMobileDevice, setIsMobileDevice] = useState(false);
    const { width } = useWindowDimensions();

    useEffect(() => {
        setIsMobileDevice(width <= 768);
    }, [width]);

    return isMobileDevice;
};
